import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import { useNavigate, Link } from 'react-router-dom';
import {
  Row,
  Col, Modal,
  CardBody, Card
} from "reactstrap";
import $ from 'jquery';
import './EditableTable.css';

import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../components/Loaders/DnaLoader.js";
import "../../../assets/custom css/loadoverlay.scss";

import Alerts from "../../../components/Alerts/alerts.js";

import CustomerService from "./Customer.service.js";
import AuthService from "../../Authentication/auth.service.js";

import DataTable from 'react-data-table-component';
import { Tooltip } from "@mui/material";

import PaymentFilter from "../../../components/Table Filters/InvoiceFilter/PaymentFilter2.js";
import AlertService from "../../../components/Alerts/alerts.js";
import PermissionAccess from '../../../PermissionAccess/Access.js';



const CustomersList = () => {

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [pdfModalIsOpenPayments, setPDFModalIsOpenPayments] = useState(false);
  const [pdfUrlPayments, setPdfUrlPayments] = useState("");
  const [pdfModalIsOpen, setPDFModalIsOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [filterInvoice_StartDate, setFilterInvoice_StartDate] = useState('');
  const [filterInvoicdue_date, setFilterInvoicdue_date] = useState('');
  const [filterDue_StartDate, setFilterDue_StartDate] = useState('');
  const [filterDudue_date, setFilterDudue_date] = useState('');
  const [search_text, setSearchText] = useState('');
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  const [loading, setLoading] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState("");
  const [searchName, setsearchName] = useState('');
  const [searchRegNo, setsearchRegNo] = useState('');
  const [searchEmail, setsearchEmail] = useState('');
  const [filterText1, setFilterText1] = useState('');
  const [filterText2, setFilterText2] = useState('');
  const [filterText3, setFilterText3] = useState('');
  const [filterBusiness, setFilterBusiness] = useState('');
  const stored_user = authData.userData

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchCustomers(0, pageLimit);
  }, [pageLimit]);
  function setFilterTextFtn(itemrec, param) {
    //iph todo: 47
    //console.log(itemrec)
    //iph todo: 47
    //console.log('Value of key1:', itemrec);
    if (param === 'users') {
      setFilterText1(itemrec);
    }
    if (param === 'orders') {
      setFilterText2(itemrec);
    }
  };
  const [value, onChange] = useState(new Date());



  const handleViewPDFPayments = (_id) => {
    var getData = {
      functionName: "Get_PDF_Payments",
      _id: _id
    }
    setLoading(true);
    CustomerService.Get_PDF_Payments(getData, authData.sessionID).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log(response.status);
      //iph todo: 47
      //console.log(response);
      if (response.status === 200) {
        setPdfUrlPayments(URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' })));
        setPDFModalIsOpenPayments(true);
      } else if (response.status === 401) {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      } else {
        // Handle other error cases, if necessary
        //iph todo: 47
        //console.log("Response status: " + response.status);
        // Display an error message or perform other actions as needed.
      }
    })
      .catch((error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        console.log("Net:-", errContent);
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      });
  };

  const PDFViewerModalPayments = () => {
    //iph todo: 47
    //console.log(pdfUrlPayments);
    return (
      <div
        className={`modal fade ${pdfModalIsOpenPayments ? "show" : ""}`}
        style={{ display: pdfModalIsOpenPayments ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content ">
            <div className="modal-header ">
              <h5 className="modal-title">Customer's Order Invoice</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setPDFModalIsOpenPayments(false)}
              ></button>
            </div>
            <div className="modal-body">
              <iframe title="pdfUrl" src={pdfUrlPayments} style={{ width: "100%", height: "500px" }} />
            </div>
          </div>
        </div>
      </div>
    );
  };
  function checkenterkey(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
  };




  function fetchCustomers(page_index, page_limit, filterText1, filterText2,
    filterInvoice_StartDate, filterInvoicdue_date,
    filterDue_StartDate, filterDudue_date, search_text) {
    var filter = {};
    //iph todo: 47
    //console.log(filterText1);
    if (filterText1) {
      //iph todo: 47
      //console.log("filterText1");
      filter["customer_id"] = filterText1
    }
    if (search_text) {
      //iph todo: 47
      //console.log("search_text");
      filter["search_text"] = search_text
    }

    if (filterText2) {
      //iph todo: 47
      //console.log("filterText1");
      filter["status"] = filterText2
    }
    let business = []
    if (filterBusiness === '') {
      if (stored_user.businesses) {
        business = stored_user.businesses
      }
    } else {
      business.push(filterBusiness);
    }


    if (filterBusiness) {
      //iph todo: 47
      //console.log("filterBusiness");
      filter["filterBusiness"] = filterBusiness
    }

    if (filterDue_StartDate) {
      //iph todo: 47
      //console.log("filterDue_StartDate");
      filter["filterDue_StartDate"] = filterDue_StartDate
    } if (filterDudue_date) {
      //iph todo: 47
      //console.log("filterDudue_date");
      filter["filterDudue_date"] = filterDudue_date
    } if (filterInvoice_StartDate) {
      //iph todo: 47
      //console.log("filterInvoice_StartDate");
      filter["filterInvoice_StartDate"] = filterInvoice_StartDate
    } if (filterInvoicdue_date) {
      filter["filterInvoicdue_date"] = filterInvoicdue_date
    }
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }

    setLoading(true);

    CustomerService.getAllPayments(authData.sessionID, offset, page_limit,business, filterText1,
      filterText2, filterInvoice_StartDate, filterInvoicdue_date, filterDue_StartDate, filterDudue_date, search_text).then((response) => {
        setLoading(false);
        //iph todo: 47
        //console.log("Get Customers response:-", response)
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        }
        else {
          //iph todo: 47
          //console.log(response.data);
          setCustomers(response.data.data);
          setTotalRows(response.data.count.count);
        }
      },
        (error) => {
          setLoading(false);
          const errContent =
            (error.response && error.response.data) || error.message || error.toString();
          //iph todo: 47
          //console.log("Net:-", errContent)
          if (errContent) {
            Alerts.swalErrorAlert(errContent)
          }
          else {
            Alerts.swalErrorAlert(t("Server Error, Please try again later."))
          }
        })
  };
  function handleClear(item) {
    if (item === 'users') {
      $("#colfilter").val('');
      setFilterText1('');
      setFilterText2('');
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
    if (item === 'action') {
      // $("#modfilter").val('');
      $("#actfilter").val('');
      setFilterText2('');
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
    if (item === 'function') {
      $("#funcfilter").val('');
      setFilterText3('');
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
  };

  function handlePageChange(page_index) {
    //iph todo: 47
    //console.log("Page index:-", page_index)
    setCurrentPage(page_index)
    fetchCustomers(page_index, pageLimit);
  }

  async function handlePerRowsChange(newPageLimit, page_index) {
    setPageLimit(newPageLimit);
  }

  function nameFilter(e) {
    //iph todo: 47
    //console.log(e.target.value);
    setsearchName(e.target.value)
  }
  function regFilter(e) {
    //iph todo: 47
    //console.log(e.target.value);
    setsearchRegNo(e.target.value)
  }
  function emailFilter(e) {
    //iph todo: 47
    //console.log(e.target.value);
    setsearchEmail(e.target.value)
  }


  function resetFilters() {
    setResetPaginationToggle(!resetPaginationToggle);
    setFilterText1('');
    setFilterBusiness('');
    setFilterInvoice_StartDate('');
    setFilterInvoicdue_date('');
    setFilterDue_StartDate('');
    setFilterDudue_date('');
    setSearchText('');
    setFilterText2('');
    fetchCustomers(0, pageLimit);

  }

  function searchCustomers() {
    setResetPaginationToggle(!resetPaginationToggle);
    const page = 0;

    // Filter values
    const filteredText1 = filterText1 || "";
    const filteredText2 = filterText2 || "";
    const FilterInvoice_StartDate1 = filterInvoice_StartDate || "";
    const FilterInvoicdue_date2 = filterInvoicdue_date || "";
    const FilterDue_StartDate3 = filterDue_StartDate || "";
    const Search_text = search_text || "";
    const FilterDudue_date4 = filterDudue_date || "";
    //iph todo: 47
    //console.log(FilterDue_StartDate3)
    //iph todo: 47
    //console.log(FilterDudue_date4)
    fetchCustomers(0, pageLimit, filteredText1, filteredText2, FilterInvoice_StartDate1,
      FilterInvoicdue_date2, FilterDue_StartDate3, FilterDudue_date4, Search_text);
  }


  function confirmDeleteCustomer(_id, invoice_id, status) {
    // if (status === 'generated') {
    let msg = t("Once deleted, you will not be able to recover this Payment Record!")
    Alerts.swalConfirmDeleteAlert(msg).then(res => {
      //iph todo: 47
      //console.log("Resp:-", res)
      if (res === true) {
        sendDelete(_id, invoice_id)
      }
    })
    // } else {
    //   AlertService.swalErrorAlert("Invoice status should be Generated")
    // }
  };


  function sendDelete(id, invoice_id) {
    setLoading(true);
    CustomerService.deletePayment(id, authData.sessionID).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Delete customer response:-", response)
      if (response.data.status) {
        fetchCustomers(currentPage, pageLimit)
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          var payload = {
            functionName: "UpdateInvoice",
            _id: invoice_id,
            status: "unpaid"
          }
          //iph todo: 47
          //console.log(payload);
          CustomerService.UpdateInvoice(payload, authData.sessionID).then((response) => {
            //iph todo: 47
            //console.log(response);
            setLoading(false);
            Alerts.swalSuccessAlert(t("Payment Deleted Successfully."))
          });

        }
        //iph todo: 47
        //console.log(response.data.message)
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't delete the customer at the moment."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Delete operation failed"))
      })
  };


  const ChangeStatus = (row) => {
    //iph todo: 47
    //console.log(row);
    let status;
    if (row.status === "In Process") {
      status = "paid";
    } else {
      status = "In Process"
    }
    var payloadData = {
      _id: row._id,
      functionName: "UpdatePayments",
      status: status

    }
    //iph todo: 47
    //console.log(payloadData);
    setLoading(true);
    CustomerService.updatePayment(payloadData, authData.sessionID).then((response) => {
      //iph todo: 47
      //console.log("API Response:-", response);
      setLoading(false);
      if (response.data.status) {
        navigate('/payments-list')
        fetchCustomers(currentPage, pageLimit)
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          Alerts.swalSuccessAlert(t("Payment Updated Successfully."));
        }
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't add Payment at the moment. Please try again later."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Network Operation failed."))
      });


  }
  const mycolumns = [
    {
      name: "Payment Date",
      selector: "payment_date",
      sortable: true,
      cell: (row) => format(parseISO(row.payment_date), 'dd-MM-yyyy'),
    },
    {
      name: "Payments",
      selector: "Payment_ID",
      width: "10%",
      sortable: true,
    },
    {
      name: "Customer Name",
      selector: (row) => {
        if (row.user_details) {
          return <div >{row.user_details ? row?.user_details[localStorage.getItem('invoice_to_field')] : ''}</div>
        } else {
          return;
        }
      },
      sortable: true,
    },
    {
      name: "Invoice Number",
      selector: "invoice_number",
      sortable: true,
      cell: (row) => {
        const invoiceNumbers = row?.invoice_number?.split(',');
        return (
          <div>
            {invoiceNumbers?.map((invoice, index) => (
              <button
                key={index}
                type="button"
                className="btn btn-link me-2"
                onClick={() => handleViewPDF(invoice.trim())}
              >
                {invoice.trim()}
              </button>
            ))}
          </div>
        );
      },
    },
    {
      name: "Method",
      selector: "payment_method",
      sortable: true,
    },
    {
      name: t('Status'),
      width: '11%',
      selector: (row) => {
        return (
          <div>
            {row.status === "partial paid" ?
              <button onClick={() => { ChangeStatus(row) }} type="button" style={{ borderColor: '#F39026', backgroundColor: '#F39026' }}
                className="btn btn-success btn-hover-shine me-3 btn">{row.status}
              </button>
              :
              row.status === "In Process" ?
                <button onClick={() => { ChangeStatus(row) }} type="button"
                  className="btn btn-danger btn-hover-shine me-3 btn">{row.status}
                </button>
                :
                row.status === "paid" ?
                  <button onClick={() => { ChangeStatus(row) }} type="button"
                    className="btn btn-success btn-hover-shine me-3 btn">{row.status}
                  </button>
                  :
                  <button onClick={() => { ChangeStatus(row) }} type="button"
                    className="btn btn-default btn-hover-shine me-3 btn">{row.status}
                  </button>
            }
          </div>
        );
      }
    },
    // {
    //   name: "Channel",
    //   selector: "channel",
    //   sortable: true,
    // },
    {
      name: "Amount",
      width: "9%",
      sortable: true,
      selector: (row) => (
        <div >{`${row.currency}${parseFloat(row.amount).toFixed(2)}`} </div>
      )
    },

    {
      name: 'Actions',
      width: "13%",
      selector: (row) => {
        return (
          <div>
            <button className="mt-2 mb-2 me-2 btn-icon btn">
              {!super_admin? current_module?.viewData === 1 &&
                <Tooltip placement="top" title={t("Payments Details")} arrow>
                  <Link to="/payments-details" state={row}>
                    <i className="pe-7s-news-paper btn-icon-wrapper text-info"> </i>
                  </Link>
                </Tooltip > :
                <Tooltip placement="top" title={t("Payments Details")} arrow>
                  <Link to="/payments-details" state={row}>
                    <i className="pe-7s-news-paper btn-icon-wrapper text-info"> </i>
                  </Link>
                </Tooltip >}

              {!super_admin? current_module?.ViewPDF === 1 &&
                <Tooltip placement="top" title="View PDF" arrow>
                  <i onClick={() => handleViewPDFPayments(row._id)} className="pe-7s-look text-primary btn-icon-wrapper"> </i>
                </Tooltip> :
                <Tooltip placement="top" title="View PDF" arrow>
                  <i onClick={() => handleViewPDFPayments(row._id)} className="pe-7s-look text-primary btn-icon-wrapper"> </i>
                </Tooltip>}

              {!super_admin? current_module?.DownloadPDF === 1 &&
                <Tooltip placement="top" title="Download PDF" arrow>
                  <i onClick={() => handlePDF(row._id)} className="pe-7s-download text-success btn-icon-wrapper text-info"> </i>
                </Tooltip>
                :
                <Tooltip placement="top" title="Download PDF" arrow>
                  <i onClick={() => handlePDF(row._id)} className="pe-7s-download text-success btn-icon-wrapper text-info"> </i>
                </Tooltip>
              }
              {!super_admin? current_module?.EditData === 1 &&
                <Tooltip placement="top" title="Update Payment" arrow>
                  <i>
                    <Link to="/update-payment" state={{ state: row, check: false }}>
                      <i className="pe-7s-pen btn-icon-wrapper text-primary"> </i>
                    </Link>
                  </i>
                </Tooltip>
                :
                <Tooltip placement="top" title="Update Payment" arrow>
                  <i>
                    <Link to="/update-payment" state={{ state: row, check: false }}>
                      <i className="pe-7s-pen btn-icon-wrapper text-primary"> </i>
                    </Link>
                  </i>
                </Tooltip>}

              {!super_admin? current_module?.DeleteData === 1 &&
                <Tooltip placement="top" title="Delete Payment" arrow>
                  <i onClick={() => confirmDeleteCustomer(row._id, row.invoice_id, row.status)} className="pe-7s-trash text-danger btn-icon-wrapper"> </i>
                </Tooltip> :
                <Tooltip placement="top" title="Delete Payment" arrow>
                  <i onClick={() => confirmDeleteCustomer(row._id, row.invoice_id, row.status)} className="pe-7s-trash text-danger btn-icon-wrapper"> </i>
                </Tooltip>}
            </button>
          </div>
        );
      }
    },
  ];
  const downloadPDF = (response) => {
    //iph todo: 47
    //console.log("PDF Data Length: ", response.data.length);
    //iph todo: 47
    //console.log("Partial PDF Data: ", response.data.slice(0, 100));
    const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

    // Create a download link and trigger the download
    const url = window.URL.createObjectURL(pdfBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = 'payment.pdf'; // Set the desired file name here.
    downloadLink.style.display = 'none';

    document.body.appendChild(downloadLink);
    downloadLink.click();

    // Clean up by removing the link and revoking the URL
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
  };

  const handleViewPDF = (invoice_number) => {
    var getData = {
      functionName: "Get_Invoice_Details",
      invoice_number: invoice_number
    };
    //iph todo: 47
    //console.log(getData);
    setLoading(true);
    //iph todo: 47
    //console.log(getData);
    CustomerService.getInvoice_PDF(getData, authData.sessionID)
      .then((response) => {
        setLoading(false);
        //iph todo: 47
        //console.log(response.status);
        //iph todo: 47
        //console.log(response);
        if (response.status === 200) {
          setPdfUrl(URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' })));
          setPDFModalIsOpen(true);
        } else if (response.status === 401) {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          // Handle other error cases, if necessary
          //iph todo: 47
          //console.log("Response status: " + response.status);
          // Display an error message or perform other actions as needed.
        }
      })
      .catch((error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        console.log("Net:-", errContent);
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      });
  };

  const PDFViewerModal = () => {
    //iph todo: 47
    //console.log(pdfUrl);
    return (
      <div
        className={`modal fade ${pdfModalIsOpen ? "show" : ""}`}
        style={{ display: pdfModalIsOpen ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content ">
            <div className="modal-header ">
              <h5 className="modal-title">Customer's Order Invoice</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setPDFModalIsOpen(false)}
              ></button>
            </div>
            <div className="modal-body">
              <iframe title="pdfUrl" src={pdfUrl} style={{ width: "100%", height: "500px" }} />
            </div>
          </div>
        </div>
      </div>
    );
  };


  const handlePDF = (_id) => {
    var getData = {
      functionName: "Get_PDF_Payments",
      _id: _id
    }
    setLoading(true);
    CustomerService.Get_PDF_Payments(getData, authData.sessionID).then((response) => {
      //iph todo: 47
      //console.log(response);
      const pre = document.createElement('pre');
      pre.textContent = response.data;
      document.body.appendChild(pre);
      setLoading(false);
      if (response.status === 200) {

        downloadPDF(response);
      } else if (response.status === 401) {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      } else {
        // Handle other error cases, if necessary
        //iph todo: 47
        //console.log("Response status: " + response.status);
        // Display an error message or perform other actions as needed.
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent);
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      })
  }
  const handlePayments = (row) => {
    if (row.status !== 'paid') {
      navigate('/add-payment', { state: row, check: false });
    } else {
      AlertService.swalErrorAlert("Invoice Already Paid Successfully")
    }

  }


  return (
    <>
      <PDFViewerModal />
      <PDFViewerModalPayments />
      <Fragment>
        <div className="app-main__outer">
          <div className="app-main__inner">
            <div className=" bg-light-gray bg-animation ">
              <div className="d-flex  justify-content-center align-items-center">
                <Col md="12" className="mx-auto app-login-box">
                  <div className="app-page-title">
                    <div className="page-title-wrapper">
                      <div className="page-title-heading fw-bold">
                        <div className="page-title-icon">
                          <i className="pe-7s-credit icon-gradient bg-tempting-azure" />
                        </div>
                        <div>
                          {t('Payments')} {t("Management")}
                          <div className="page-title-subheading">
                            {t(`View & Download Details of Invoices & Payments Of Doctors.`)}
                          </div>
                        </div>
                      </div>
                      <div className="page-title-actions">
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-success btn-hover-shine me-3">
                          {t("Back")}
                        </button>
                      </div>
                    </div>
                  </div>
                  <Row>


                    <Fragment>
                      <Row>
                        <Col md="12">
                          <Card className="main-card mb-3">
                            <CardBody>
                              <LoadingOverlay tag="div" active={loading}
                                styles={{ overlay: (base) => ({ ...base }) }}
                                spinner={<DNALoader />}>


                                <PaymentFilter
                                  super_admin={super_admin}
                                  accessPages={accessPages}
                                  filterBusiness={filterBusiness}
                                  onFilterBusiness={(e) => {
                                    //iph todo: 47
                                    //console.log(e.target.value);
                                    setFilterBusiness(e.target.value, 'users');
                                  }}
                                  authData={authData}
                                  current_module={current_module}

                                  onFilterInvoice_StartDate={setFilterInvoice_StartDate}
                                  onFilterInvoicdue_date={setFilterInvoicdue_date}

                                  onFilterDue_StartDate={setFilterDue_StartDate}
                                  onFilterDudue_date={setFilterDudue_date}
                                  search_text={search_text}
                                  onSearch_text={(e) => {
                                    setSearchText(e.target.value);
                                  }}



                                  searchCustomers={searchCustomers}
                                  resetFilters={resetFilters}
                                  onFilter1={(e) => {
                                    //iph todo: 47
                                    //console.log(e.target.value);
                                    setFilterTextFtn(e.target.value, 'users');
                                  }}
                                  onFilter2={(e) => {
                                    //iph todo: 47
                                    //console.log(e.target.value);
                                    setFilterText2(e.target.value, 'users');
                                  }}
                                  handleKeyDown={(event) => checkenterkey(event)}
                                  filterText1={filterText1}
                                  filterText2={filterText2}
                                  filterInvoice_StartDate={filterInvoice_StartDate}
                                  filterInvoicdue_date={filterInvoicdue_date}
                                  filterDue_StartDate={filterDue_StartDate}
                                  filterDudue_date={filterDudue_date}

                                  onClear={() => handleClear('users')}
                                />

                                <DataTable
                                  data={customers}
                                  columns={mycolumns}
                                  pagination
                                  fixedHeader
                                  fixedHeaderScrollHeight="400px"
                                  paginationServer
                                  paginationTotalRows={totalRows}
                                  onChangePage={handlePageChange}
                                  onChangeRowsPerPage={handlePerRowsChange}
                                  paginationResetDefaultPage={resetPaginationToggle}
                                />
                              </LoadingOverlay>

                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </Fragment>
                  </Row>
                </Col>
              </div>
            </div>
          </div>
        </div>

      </Fragment>
    </>

  );
};

export default CustomersList;